// Dependencies
import React from 'react';
import radium from 'radium';

import CustomerAddressData from "../overview/CustomerAddressData";
import ShoppingCartEventOverview from "../overview/ShoppingCartEventOverview";
import ShoppingCartTotal from "../overview/ShoppingCartTotal";
import CheckoutButtons from "../CheckoutButtons";
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import '../CheckoutProcess.scss';
import MarketingApproval from "../overview/MarketingApproval";
import TermsAndConditions from "../overview/TermsAndConditions";
import PaymentShipment from "../overview/PaymentShipment";

function PURCHASE_OVERVIEW(props) {
	const context = React.useContext(ThemeContext);
	const defaultNextBtnTextKey = props.checkoutProps.output.displayShoppingcart.total.value > 0 ? 'buttonTextBuyNow' : 'buttonTextRegisterNow';
	const nextBtnTextKey = props.checkoutProps.output.nextBtnLabelKey || null
	const [marketingApproval, setMarketingApproval] = React.useState(props.checkoutProps.output.customer.legalAddress.marketingApproval)
	const [termsAndConditions, setTermsAndConditions] = React.useState(false)

	const style = {
		checkboxContainer: {
			'@media (min-width : 768px)': {
				maxWidth: '45%',
				display: 'table',
			},
			margin: 'auto',
		}
	}

	return <div className="checkout">
		<h1 className="page__headline"
			dangerouslySetInnerHTML={{
			__html: context.themeManager
				.getThemeTextOrHardcodedDefault('purchaseOverviewHeadline'),
		}}
		/>
		<CustomerAddressData
			shipmentAddress={props.checkoutProps.output.customer.shipmentAddress}
			legalAddress={props.checkoutProps.output.customer.legalAddress}
			addressesDiffer={props.checkoutProps.output.customer.addressesDiffer}/>
		<PaymentShipment
			selectedShipmentType={props.checkoutProps.output.displayShoppingcart.shipmentType}
			selectedShipmentTypeFee={props.checkoutProps.output.displayShoppingcart.shipmentFee}
			selectedPaymentType={props.checkoutProps.method}/>
		<ShoppingCartEventOverview
			shoppingCartEvents={props.checkoutProps.output.displayShoppingcart.events}
			subTotal={props.checkoutProps.output.displayShoppingcart.subTotal.value}/>

		<ShoppingCartTotal total={props.checkoutProps.output.displayShoppingcart.total.value}/>
		<div style={style.checkboxContainer}>
			<MarketingApproval
				marketingApproval={marketingApproval}
				onMarketingApprovalChange={(marketingApproval)=>setMarketingApproval(marketingApproval)}>
			</MarketingApproval>
			<TermsAndConditions
				termsAndConditions={termsAndConditions}
				onTermsAndConditionsChange={(termsAndConditions)=>setTermsAndConditions(termsAndConditions)}
			>
			</TermsAndConditions>
		</div>
		<CheckoutButtons
			btnResetLabel={props.btnLabels.resetBtnLabel}
			btnNextLabel={
				context.themeManager.getThemeTextOrHardcodedDefault(nextBtnTextKey) ||
				props.btnLabels.nextBtnLabel ||
				context.themeManager.getThemeTextOrHardcodedDefault(defaultNextBtnTextKey)}
			btnBackLabel={props.btnLabels.backBtnLabel}
			onBackClick={()=>props.pop({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
			onNextClick={()=>props.next({
				method: props.checkoutProps.method,
				provider: props.checkoutProps.provider,
				input:{marketingApproval: marketingApproval}})}
			onResetClick={()=>props.reset({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
			disableNextButton={!termsAndConditions}
		/>
	</div>;
}

const RadiumOVERVIEW_PAGE = radium(PURCHASE_OVERVIEW);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumOVERVIEW_PAGE.name = PURCHASE_OVERVIEW.name

export default RadiumOVERVIEW_PAGE;
